import React from 'react';
import { colors } from '../../config/theme';
import IconWarning from '../../assets/icons/IconWarning.svg';
import Text from '../../components/text';
import Element from '../../components/element';
import Flex from '../../components/flex';

const Select = props => {
  const {
    label,
    name,
    register,
    mainOption,
    options,
    errors,
    selectedValue,
    onValueChange
  } = props;
  const errMsg = errors?.[name]?.message;
  const borderBottomRed = { borderBottomColor: colors.ceriseRed };
  const { onChange: onOptionChange, ...restRegister } = register(name);

  const displayError = _ => (
    <Flex marginTop="5px">
      <Element type="img" attrs={{ src: IconWarning }} marginRight="5px" />
      <Text family="GTAM" color={colors.ceriseRed}>
        {errMsg}
      </Text>
    </Flex>
  );

  return (
    <>
      <label>{label}</label>
      <select
        {...restRegister}
        // className={classes.fieldNoBorder}
        style={errMsg && borderBottomRed}
        onChange={e => {
          onOptionChange(e);
          onValueChange && onValueChange();
        }}
      >
        <option value="">{mainOption}</option>
        {options.map(data => (
          <option value={data.value} selected={selectedValue === data.value}>
            {data.name}
          </option>
        ))}
      </select>
      {errMsg && displayError()}
    </>
  );
};

export default Select;
